module.exports = __webpack_public_path__ + "static/media/fighting-gravity.0e3fea18.jpg";